(function ($) {

    $(function () {

        var backButton = $('.shop-product-section .back-link');

        if (backButton.length === 0) {
            return;
        }

        backButton.on('click', function (e) {
            e.preventDefault();

            window.history.back();
        });

    });

})(jQuery);